/** @format */
import { HeaderCheckBoxSelectListElement } from '../../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { FeatureTypes } from '../../features/FeaturesTypes';

export enum ServiceUseTypeMap {
    PREPAID = 1,
    POSTPAID = 2,
    BOTH = 3,
}

export enum ServiceUseType {
    PREPAID = 'Prepaid',
    POSTPAID = 'Postpaid',
    BOTH = 'Postpaid/Prepaid',
}

const serviceUseTypes = [
    { name: ServiceUseType.PREPAID, value: ServiceUseTypeMap.PREPAID },
    { name: ServiceUseType.POSTPAID, value: ServiceUseTypeMap.POSTPAID },
    { name: ServiceUseType.BOTH, value: ServiceUseTypeMap.BOTH },
] as Array<HeaderCheckBoxSelectListElement>;

export enum OperatorMvneType {
    PLUS = 'no-set',
    OPL = 'Orange',
}

export enum OperatorMvneTypeMap {
    OPL = 2,
}

export enum ServicesMvneType {
    BME = 'BME',
    SDG = 'SDG',
    MCBME = 'MCBME',
}

export enum ServicesMvneTypeMap {
    BME = 4,
    SDG = 5,
    MCBME = 6,
}

const servicesMvneTypes = [
    { name: ServicesMvneType.SDG, value: ServicesMvneTypeMap.SDG },
    { name: ServicesMvneType.BME, value: ServicesMvneTypeMap.BME },
    { name: ServicesMvneType.MCBME, value: ServicesMvneTypeMap.MCBME },
] as Array<{ name: string; value: number }>;

export const useOperatorType = (featureOperatorType: FeatureTypes): Array<HeaderCheckBoxSelectListElement> => {
    const element: Array<HeaderCheckBoxSelectListElement> = [];
    for (let i = 0; i < featureOperatorType.operatorType.length; i++) {
        if (featureOperatorType.operatorType[i] === OperatorMvneTypeMap.OPL) {
            element.push({ name: OperatorMvneType.OPL.toString(), value: OperatorMvneTypeMap.OPL });
        }
    }
    return element;
};

export const useOperatorServiceUseType = (): Array<HeaderCheckBoxSelectListElement> => {
    return serviceUseTypes;
};

export const useServiceUseType = (): Array<HeaderCheckBoxSelectListElement> => {
    return serviceUseTypes;
};

export const useServiceType = (
    featureOperatorType: FeatureTypes,
    excludeServiceType: string | null = null
): Array<HeaderCheckBoxSelectListElement> => {
    const element: Array<HeaderCheckBoxSelectListElement> = [];
    let found: string | undefined | null = null;
    for (let i = 0; i < servicesMvneTypes.length; i++) {
        found = featureOperatorType.nsType.find((element) => servicesMvneTypes[i].name === element);
        if (found && excludeServiceType !== servicesMvneTypes[i].name) {
            element.push({ name: servicesMvneTypes[i].name, value: servicesMvneTypes[i].value });
        }
    }
    return element;
};

export const useOperatorAccess = (operator: number): boolean => {
    const operators = process.env.REACT_APP_SUPPORT_OPERATOR_TYPE ? JSON.parse(process.env.REACT_APP_SUPPORT_OPERATOR_TYPE) : null;

    return Array.isArray(operators) && operators.includes(operator);
};
